export default function replaceStringAt(index, replacement, str) {
  return str.substr(0, index) + replacement + str.substr(index + replacement.length);
}
